<form class="form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
  <!-- Password -->
  <div class="form-field">
    <label for="invitation-password">
      {{ "password.label" | translate }}
    </label>

    <div class="input-wrapper">
      <lucide-icon name="lock" [size]="19"></lucide-icon>

      <input
        id="invitation-password"
        [type]="passwordVisible ? 'text' : 'password'"
        formControlName="password"
        autocomplete="new-password"
        [placeholder]="'password.placeholder' | translate"
      />

      <button
        type="button"
        class="visibility-button"
        (click)="togglePassword()"
        [attr.aria-label]="passwordVisible ? ('password.hide' | translate) : ('password.show' | translate)"
      >
        <lucide-icon [name]="passwordVisible ? 'eye' : 'eye-off'" [size]="19"></lucide-icon>
      </button>
    </div>

    <span class="field-error" *ngIf="form.controls.password.touched && form.controls.password.errors?.['required']">
      {{ "common.required" | translate }}
    </span>

    <span class="field-error" *ngIf="form.controls.password.touched && form.controls.password.errors?.['pattern']">
      {{ "password.pattern" | translate }}
    </span>
  </div>

  <!-- Confirmation -->
  <div class="form-field">
    <label for="invitation-password-confirmation">
      {{ "password.confirm.label" | translate }}
    </label>

    <div class="input-wrapper">
      <lucide-icon name="lock-keyhole" [size]="19"></lucide-icon>

      <input
        id="invitation-password-confirmation"
        [type]="confirmationVisible ? 'text' : 'password'"
        formControlName="confirmPassword"
        autocomplete="new-password"
        [placeholder]="'password.confirm.placeholder' | translate"
      />

      <button
        type="button"
        class="visibility-button"
        (click)="toggleConfirmation()"
        [attr.aria-label]="confirmationVisible ? ('password.hide' | translate) : ('password.show' | translate)"
      >
        <lucide-icon [name]="confirmationVisible ? 'eye' : 'eye-off'" [size]="19"></lucide-icon>
      </button>
    </div>

    <span class="field-error" *ngIf="form.controls.confirmPassword.touched && form.controls.confirmPassword.errors?.['required']">
      {{ "common.required" | translate }}
    </span>

    <span class="field-error" *ngIf="form.controls.confirmPassword.touched && form.controls.confirmPassword.errors?.['matching']">
      {{ "password.confirm.mismatch" | translate }}
    </span>
  </div>

  <button type="submit" class="primary-button" [disabled]="form.invalid">
    {{ "invitation.register.submit" | translate }}
  </button>
</form>
